import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  statisticsItemItemsExcelDataRequest,
  statisticsItemItemsListRequest
} from '../../../../redux/actions/monitoring/statisticsActions';
import { DAYS_AGO, DIFF_VALUE, SELECT_FORM_STYLE } from '../../../../constants/base';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import { itemLevel, itemType } from '../../../../constants/nft';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers';
import TextField from '@mui/material/TextField';
import BtnIcons from '../../../../api/images/btnIcons';
import SimpleLine from '../ChartComponents/SimpleLine';
import Notification from '../../../../components/Notification/Notification';
import timeFormAPI from '../../../../api/ui/timeFormAPI';
import excelDownload from '../../../../api/excelDownload/excelDownload';
import sortKey from '../../../../api/excelDownload/sortKey';
import BOTable from "../../../../components/Tables/BOTable";
import useSchemaMonitoringItem from "../../../../schema/table-schema/useSchemaMonitoringItem";
import DataItem from "../DataItem";
import {
    SearchBtnContainer,
    SearchContainer,
    SearchContent,
    SearchDateRange,
    SearchLabel,
    SearchRow
} from "../../../../components/Search/searchSection";
import FetchLoading from "../../../../components/Loading/FetchLoading";

function items() {
  // -- component const --//
  // 아이템 타입
  const itemTypes = Object.keys(itemType).map(key => ({
    key: itemType[key],
    value: key.toString(),
  }));

  // 아이템 레벨
  const itemLevels = Object.keys(itemLevel).map(key => ({
    key: itemLevel[key],
    value: key.toString(),
  }));

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  // -- state --//
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 날짜 범위
  const [activeDateRangeToken, setActiveDateRangeToken] = useState(7);

  // 데이터 설정
  const [strData, setStrData] = useState([{}]);
  const [tableData, setTableData] = useState([{}]);

  const [ITEMLevelTable, setITEMLevelsTable] = useState([]);
  const [ITEMTypeTable, setITEMTypesTable] = useState([]);

  const schema = useSchemaMonitoringItem();
  const [data, setData] = useState([{}]);
  const [lineData, setLineData] = useState([{}]);

  const [ITEMLevel, setITEMLevels] = useState([]);
  const [ITEMType, setITEMTypes] = useState([]);

  const [startAt, setStartAt] = useState(DAYS_AGO(activeDateRangeToken));
  const [endAt, setEndAt] = useState(DAYS_AGO(1));

  const [isReset, setIsReset] = useState(false);

  // 로딩
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGraph, setIsLoadingGraph] = useState(false);

  // Excel Data
  const [excelData, setExcelData] = useState();

  // -- func & handler --//
  const handleChange = (event, type) => {
    // const {
    //   target: { value },
    // } = event;

    // 전체 선택시 빈값으로 대치
    const value = event.target.value.includes('')
      ? ['']
      : event.target.value;

    if (type === 'grade') {
      setITEMLevels(value);
    } else if (type === 'type') {
      setITEMTypes(value);
    } else if (type === 'grade-table') {
      setITEMLevelsTable(value);
    } else if (type === 'type-table') {
      setITEMTypesTable(value);
    }
  };

  const fetchList = () => {
    setIsLoadingGraph(true);

    dispatch(
      statisticsItemItemsListRequest({
        beginDate: startAt,
        endDate: endAt,
        itemType: ITEMType.map(item => String(item)).join(','),
        gemType: '',
        level: ITEMLevel.map(item => String(item)).join(','),
        isGem: false,
        callback: (data) => {
          console.log(data);
          setData(data.list);

          setIsLoadingGraph(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoadingGraph(false);
        },
      })
    );

    // dispatch(
    //   statisticsItemItemsExcelDataRequest({
    //     beginDate: startAt,
    //     endDate: endAt,
    //     isGem: false,
    //     callback: (data) => {
    //       console.log('요청 결과: ', data);
    //       setExcelData(data?.list);
    //     },
    //     error: (e) => {
    //       console.log(e);
    //       setNotificationMessage(e.toString());
    //       setShowNotification(true);
    //     },
    //   })
    // );

  };

  const handleClickDownload = () => {
    // 파일 명 설정
    const fileName = `아이템_아이템_${startAt}_${endAt}`;

    excelDownload(fileName, excelData, sortKey.statistics.item_item);
  };

  // -- react hooks --//
  useEffect(() => {
    setStartAt(DAYS_AGO(activeDateRangeToken));
    setEndAt(DAYS_AGO(1))
  }, [activeDateRangeToken]);

  useEffect(() => {
    fetchList();

    setIsLoading(true);

    dispatch(
      statisticsItemItemsListRequest({
        beginDate: DAYS_AGO(2),
        endDate: DAYS_AGO(1),
        itemType: '',
        gemType: '',
        level: '',
        isGem: false,
        callback: (data) => {
          console.log(data);
          setStrData(data.list);

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      })
    );
  }, []);

  useEffect(() => {
    setIsLoading(true);

    // 조건에 따른 등록 및 거래 현황 조회
    dispatch(
      statisticsItemItemsListRequest({
        beginDate: DAYS_AGO(2),
        endDate: DAYS_AGO(1),
        itemType: ITEMTypeTable.map(item => String(item)).join(','),
        gemType: '',
        level: ITEMLevelTable.map(item => String(item)).join(','),
        isGem: false,
        callback: (data) => {
          console.log(data);
          setStrData(data.list);

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      })
    );
  }, [ITEMTypeTable, ITEMLevelTable]);

  // 요청해서 온 데이터 디자인에 맞게 key 가공
  useEffect(() => {
    const updateData = data && data.map(data => {

      const newItemCount = data.newItemCount || 0;
      const burnedItemCount = data.burnedItemCount || 0;
      const newDate = timeFormAPI.changeDataDate(data.targetDate);

      return {
        '아이템 생성': parseFloat(newItemCount),
        '아이템 소각': parseFloat(burnedItemCount),

        time: newDate
      };
    });

    setLineData(updateData)
  }, [data]);

  useEffect(() => {
    const updateData = strData && strData.map(data => {

      const totalItemCount = data.totalItemCount || 0;
      const newItemCount = data.newItemCount || 0;
      const burnedItemCount = data.burnedItemCount || 0;
      const targetDate = data.targetDate;

      return {
        totalItemCount: totalItemCount,
        newItemCount: newItemCount,
        burnedItemCount: burnedItemCount,
        targetDate: targetDate,
      }
    });

    setTableData(updateData);
  }, [strData]);

  useEffect(() => {
      if(!isReset){
          return;
      }

      fetchList();
      setIsReset(false);
  }, [ITEMType, ITEMLevel]);

  return (
    <div>

      <div>
        <div className="contentsArea">

            <div className="rowDiv">
                <div className="leftDiv" style={{width:'100%'}}>
                    <div className={"contentTitle"}>
                        등록 및 거래 현황 { `(${timeFormAPI.changeDataDate(DAYS_AGO(1))} 기준)` }
                    </div>
                </div>

                <div className="rightDiv" style={{justifyContent: "flex-end"}}>
                    <FormControl id={"formController"}>
                        <Select
                            displayEmpty
                            multiple
                            value={ITEMTypeTable}
                            onChange={(event) => handleChange(event, 'type-table')}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return <div style={{ color: '#999' }}>아이템 종류</div>;
                                }

                                return selected
                                    .map((value) => itemTypes.find((item) => item.value === value)?.key)
                                    .filter(Boolean)
                                    .join(', ');
                            }}
                            style={SELECT_FORM_STYLE}
                        >
                            <MenuItem value="all" style={{ padding: 5, gap: 5 }}>
                                <input
                                    type="checkbox"
                                    checked={ITEMTypeTable.length === itemTypes.length}
                                    onChange={(event) => {
                                        const checked = event.target.checked;
                                        setITEMTypesTable(checked ? itemTypes.map((item) => item.value) : []);
                                    }}
                                />
                                <ListItemText primary="전체 선택" />
                            </MenuItem>
                            {itemTypes.map((item) => (
                                <MenuItem
                                    key={item.value}
                                    value={item.value}
                                    style={{
                                        padding: 5,
                                        gap: 5
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={ITEMTypeTable.includes(item.value)}
                                        onChange={(event) => {
                                            const checked = event.target.checked;
                                            setITEMTypesTable((prevITEMTypesTable) => {
                                                if (checked) {
                                                    return [...prevITEMTypesTable, item.value];
                                                } else {
                                                    return prevITEMTypesTable.filter((value) => value !== item.value);
                                                }
                                            });
                                        }}
                                    />
                                    <ListItemText primary={item.key} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl id={"formController"}>
                        <Select
                            displayEmpty
                            multiple
                            value={ITEMLevelTable}
                            onChange={(event) => handleChange(event, 'grade-table')}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return <div style={{ color: '#999' }}>아이템 레벨</div>;
                                }

                                return selected
                                    .map((value) => itemLevels.find((item) => item.value === value)?.key)
                                    .filter(Boolean)
                                    .join(', ');
                            }}
                            style={SELECT_FORM_STYLE}
                        >
                            <MenuItem value="all" style={{ padding: 5, gap: 5 }}>
                                <input
                                    type="checkbox"
                                    checked={ITEMLevelTable.length === itemLevels.length}
                                    onChange={(event) => {
                                        const checked = event.target.checked;
                                        setITEMLevelsTable(checked ? itemLevels.map((item) => item.value) : []);
                                    }}
                                />
                                <ListItemText primary="전체 선택" />
                            </MenuItem>
                            {itemLevels.map((item) => (
                                <MenuItem
                                    key={item.value}
                                    value={item.value}
                                    style={{
                                        padding: 5,
                                        gap: 5
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={ITEMLevelTable.includes(item.value)}
                                        onChange={(event) => {
                                            const checked = event.target.checked;
                                            setITEMLevelsTable((prevITEMLevelsTable) => {
                                                if (checked) {
                                                    return [...prevITEMLevelsTable, item.value];
                                                } else {
                                                    return prevITEMLevelsTable.filter((value) => value !== item.value);
                                                }
                                            });
                                        }}
                                    />
                                    <ListItemText primary={item.key} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                </div>
            </div>

          {
            isLoading ?
                <FetchLoading/>
              : tableData.slice(0, -1).map((data, index) => (

              <div key={index} style={{padding: "10px 15px"}}>
                <div className="rowDiv" style={{
                  width: '100%',
                  height: '100%',
                  padding: 5
                }}>

                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%'
                  }}>
                    <div style={{ display: 'flex', gap: 5 }}>

                        <DataItem
                            label="소각한 아이템"
                            value={tableData[index + 1]?.burnedItemCount}
                            prevValue={tableData[index]?.burnedItemCount}
                            targetDate={tableData[index + 1]?.targetDate}
                            style={{ width: '100%' }}
                        />

                        <DataItem
                            label="새 아이템"
                            value={tableData[index + 1]?.newItemCount}
                            prevValue={tableData[index]?.newItemCount}
                            targetDate={tableData[index + 1]?.targetDate}
                            style={{ width: '100%' }}
                        />

                        <DataItem
                            label="총 아이템"
                            value={tableData[index + 1]?.totalItemCount}
                            prevValue={tableData[index]?.totalItemCount}
                            targetDate={tableData[index + 1]?.targetDate}
                            style={{ width: '100%' }}
                        />
                    </div>
                  </div>
                </div>
              </div>

            ))
          }

        </div>

      </div>

      <div className="spaceDiv10"/>

        <SearchContainer>
            <SearchRow>
                <SearchLabel text={"날짜"}/>
                <SearchDateRange
                    startAt={startAt}
                    endAt={endAt}
                    setStartAt={setStartAt}
                    setEndAt={setEndAt}
                />
            </SearchRow>

            <SearchRow>
                <SearchLabel text={"아이템 종류"}/>
                <SearchContent>
                    <FormControl id={'formController'}>
                        <Select
                            displayEmpty
                            multiple
                            value={ITEMType}
                            onChange={(event) => handleChange(event, 'type')}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return <div style={{ color: '#999' }}>아이템 종류</div>;
                                }

                                return selected
                                    .map((value) => itemTypes.find((item) => item.value === value)?.key)
                                    .filter(Boolean)
                                    .join(', ');
                            }}
                            style={SELECT_FORM_STYLE}
                        >
                            <MenuItem value="all" style={{
                                padding: 5,
                                gap: 5
                            }}>
                                <input
                                    type="checkbox"
                                    checked={ITEMType.length === itemTypes.length}
                                    onChange={(event) => {
                                        const checked = event.target.checked;
                                        setITEMTypes(checked ? itemTypes.map((item) => item.value) : []);
                                    }}
                                />
                                <ListItemText primary="전체 선택"/>
                            </MenuItem>
                            {itemTypes.map((item) => (
                                <MenuItem
                                    key={item.value}
                                    value={item.value}
                                    style={{
                                        padding: 5,
                                        gap: 5
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={ITEMType.includes(item.value)}
                                        onChange={(event) => {
                                            const checked = event.target.checked;
                                            setITEMTypes((prevITEMTypes) => {
                                                if (checked) {
                                                    return [...prevITEMTypes, item.value];
                                                } else {
                                                    return prevITEMTypes.filter((value) => value !== item.value);
                                                }
                                            });
                                        }}
                                    />
                                    <ListItemText primary={item.key}/>
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                </SearchContent>

                <SearchLabel text={"아이템 레벨"}/>
                <SearchContent>
                    <FormControl id={'formController'}>
                        <Select
                            displayEmpty
                            multiple
                            value={ITEMLevel}
                            onChange={(event) => handleChange(event, 'grade')}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return <div style={{ color: '#999' }}>아이템 레벨</div>;
                                }

                                return selected
                                    .map((value) => itemLevels.find((item) => item.value === value)?.key)
                                    .filter(Boolean)
                                    .join(', ');
                            }}
                            style={SELECT_FORM_STYLE}
                        >
                            <MenuItem value="all" style={{
                                padding: 5,
                                gap: 5
                            }}>
                                <input
                                    type="checkbox"
                                    checked={ITEMLevel.length === itemLevels.length}
                                    onChange={(event) => {
                                        const checked = event.target.checked;
                                        setITEMLevels(checked ? itemLevels.map((item) => item.value) : []);
                                    }}
                                />
                                <ListItemText primary="전체 선택"/>
                            </MenuItem>
                            {itemLevels.map((item) => (
                                <MenuItem
                                    key={item.value}
                                    value={item.value}
                                    style={{
                                        padding: 5,
                                        gap: 5
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={ITEMLevel.includes(item.value)}
                                        onChange={(event) => {
                                            const checked = event.target.checked;
                                            setITEMLevels((prevITEMLevels) => {
                                                if (checked) {
                                                    return [...prevITEMLevels, item.value];
                                                } else {
                                                    return prevITEMLevels.filter((value) => value !== item.value);
                                                }
                                            });
                                        }}
                                    />
                                    <ListItemText primary={item.key}/>
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                </SearchContent>
            </SearchRow>

        </SearchContainer>

        <SearchBtnContainer
            handleSearchClick={() => {
                fetchList();
            }}
            handleResetClick={() => {
                setITEMLevels([]);
                setITEMTypes([]);

                setStartAt(DAYS_AGO(activeDateRangeToken));
                setEndAt(DAYS_AGO(1));

                setIsReset(true);
            }}
        />



      {/*<div className="contentsArea paddingAll" style={{ padding: 5 }}>*/}
      {/*  <div className="rowDiv">*/}
      {/*    <div className="titleDiv flex-space-between">*/}
      {/*      <div className="left">*/}
      {/*        아이템 생성/소각 지표*/}
      {/*      </div>*/}

      {/*      <div className="right">*/}

      {/*      </div>*/}
      {/*    </div>*/}
      {/*    <div className="spaceDiv10"/>*/}
      {/*    <div className="descDiv" style={{ alignItems: 'center' }}>*/}

      {/*      <FormControl id={'formController'}>*/}
      {/*        <Select*/}
      {/*          displayEmpty*/}
      {/*          multiple*/}
      {/*          value={ITEMType}*/}
      {/*          onChange={(event) => handleChange(event, 'type')}*/}
      {/*          renderValue={(selected) => {*/}
      {/*            if (selected.length === 0) {*/}
      {/*              return <div style={{ color: '#999' }}>아이템 종류</div>;*/}
      {/*            }*/}

      {/*            return selected*/}
      {/*              .map((value) => itemTypes.find((item) => item.value === value)?.key)*/}
      {/*              .filter(Boolean)*/}
      {/*              .join(', ');*/}
      {/*          }}*/}
      {/*          style={SELECT_FORM_STYLE}*/}
      {/*        >*/}
      {/*          <MenuItem value="all" style={{*/}
      {/*            padding: 5,*/}
      {/*            gap: 5*/}
      {/*          }}>*/}
      {/*            <input*/}
      {/*              type="checkbox"*/}
      {/*              checked={ITEMType.length === itemTypes.length}*/}
      {/*              onChange={(event) => {*/}
      {/*                const checked = event.target.checked;*/}
      {/*                setITEMTypes(checked ? itemTypes.map((item) => item.value) : []);*/}
      {/*              }}*/}
      {/*            />*/}
      {/*            <ListItemText primary="전체 선택"/>*/}
      {/*          </MenuItem>*/}
      {/*          {itemTypes.map((item) => (*/}
      {/*            <MenuItem*/}
      {/*              key={item.value}*/}
      {/*              value={item.value}*/}
      {/*              style={{*/}
      {/*                padding: 5,*/}
      {/*                gap: 5*/}
      {/*              }}*/}
      {/*            >*/}
      {/*              <input*/}
      {/*                type="checkbox"*/}
      {/*                checked={ITEMType.includes(item.value)}*/}
      {/*                onChange={(event) => {*/}
      {/*                  const checked = event.target.checked;*/}
      {/*                  setITEMTypes((prevITEMTypes) => {*/}
      {/*                    if (checked) {*/}
      {/*                      return [...prevITEMTypes, item.value];*/}
      {/*                    } else {*/}
      {/*                      return prevITEMTypes.filter((value) => value !== item.value);*/}
      {/*                    }*/}
      {/*                  });*/}
      {/*                }}*/}
      {/*              />*/}
      {/*              <ListItemText primary={item.key}/>*/}
      {/*            </MenuItem>*/}
      {/*          ))}*/}
      {/*        </Select>*/}
      {/*      </FormControl>*/}

      {/*      <FormControl id={'formController'}>*/}
      {/*        <Select*/}
      {/*          displayEmpty*/}
      {/*          multiple*/}
      {/*          value={ITEMLevel}*/}
      {/*          onChange={(event) => handleChange(event, 'grade')}*/}
      {/*          renderValue={(selected) => {*/}
      {/*            if (selected.length === 0) {*/}
      {/*              return <div style={{ color: '#999' }}>아이템 레벨</div>;*/}
      {/*            }*/}

      {/*            return selected*/}
      {/*              .map((value) => itemLevels.find((item) => item.value === value)?.key)*/}
      {/*              .filter(Boolean)*/}
      {/*              .join(', ');*/}
      {/*          }}*/}
      {/*          style={SELECT_FORM_STYLE}*/}
      {/*        >*/}
      {/*          <MenuItem value="all" style={{*/}
      {/*            padding: 5,*/}
      {/*            gap: 5*/}
      {/*          }}>*/}
      {/*            <input*/}
      {/*              type="checkbox"*/}
      {/*              checked={ITEMLevel.length === itemLevels.length}*/}
      {/*              onChange={(event) => {*/}
      {/*                const checked = event.target.checked;*/}
      {/*                setITEMLevels(checked ? itemLevels.map((item) => item.value) : []);*/}
      {/*              }}*/}
      {/*            />*/}
      {/*            <ListItemText primary="전체 선택"/>*/}
      {/*          </MenuItem>*/}
      {/*          {itemLevels.map((item) => (*/}
      {/*            <MenuItem*/}
      {/*              key={item.value}*/}
      {/*              value={item.value}*/}
      {/*              style={{*/}
      {/*                padding: 5,*/}
      {/*                gap: 5*/}
      {/*              }}*/}
      {/*            >*/}
      {/*              <input*/}
      {/*                type="checkbox"*/}
      {/*                checked={ITEMLevel.includes(item.value)}*/}
      {/*                onChange={(event) => {*/}
      {/*                  const checked = event.target.checked;*/}
      {/*                  setITEMLevels((prevITEMLevels) => {*/}
      {/*                    if (checked) {*/}
      {/*                      return [...prevITEMLevels, item.value];*/}
      {/*                    } else {*/}
      {/*                      return prevITEMLevels.filter((value) => value !== item.value);*/}
      {/*                    }*/}
      {/*                  });*/}
      {/*                }}*/}
      {/*              />*/}
      {/*              <ListItemText primary={item.key}/>*/}
      {/*            </MenuItem>*/}
      {/*          ))}*/}
      {/*        </Select>*/}
      {/*      </FormControl>*/}

      {/*      <div className="descDiv dateSmall">*/}
      {/*        <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*          <DatePicker*/}
      {/*            onChange={(date) => {*/}
      {/*              setStartAt(date.format('YYYY-MM-DD'));*/}
      {/*            }}*/}
      {/*            value={startAt}*/}
      {/*            renderInput={(params) => (*/}
      {/*              <TextField {...params} variant="standard"/>*/}
      {/*            )}*/}
      {/*          />*/}
      {/*        </LocalizationProvider>*/}

      {/*        <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*          <DatePicker*/}
      {/*            onChange={(date) => {*/}
      {/*              setEndAt(date.format('YYYY-MM-DD'));*/}
      {/*            }}*/}
      {/*            value={endAt}*/}
      {/*            renderInput={(params) => (*/}
      {/*              <TextField {...params} variant="standard"/>*/}
      {/*            )}*/}
      {/*          />*/}
      {/*        </LocalizationProvider>*/}

      {/*      </div>*/}

      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeToken === 7 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(7);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        주*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeToken === 30 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(30);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        월*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeToken === 90 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(90);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        3개월*/}
      {/*      </button>*/}

      {/*      <button className="defaultBtn"*/}
      {/*              onClick={() => {*/}
      {/*                // handleSearchClick;*/}
      {/*                fetchList();*/}
      {/*              }}*/}
      {/*      >*/}
      {/*        조회*/}
      {/*      </button>*/}

      {/*      <button className="defaultBtn fit purple" onClick={handleClickDownload}>*/}
      {/*        <img src={BtnIcons.downloadIcon} alt={'다운로드'}/>*/}
      {/*        엑셀 다운로드*/}
      {/*      </button>*/}

      {/*    </div>*/}
      {/*  </div>*/}

      {/*  /!*{*!/*/}
      {/*  /!*  isLoadingGraph ? (*!/*/}
      {/*  /!*      <div className="rowDiv" style={{*!/*/}
      {/*  /!*        width: '100%',*!/*/}
      {/*  /!*        height: 520,*!/*/}
      {/*  /!*        display: 'flex',*!/*/}
      {/*  /!*        justifyContent: 'center',*!/*/}
      {/*  /!*        padding: 'unset'*!/*/}
      {/*  /!*      }}>*!/*/}
      {/*  /!*        Loading...*!/*/}
      {/*  /!*      </div>*!/*/}
      {/*  /!*    )*!/*/}
      {/*  /!*    : <div className="rowDiv" style={{*!/*/}
      {/*  /!*  height: 520,*!/*/}
      {/*  /!*  padding: 'unset'*!/*/}
      {/*  /!*}}>*!/*/}
      {/*  /!*  <div className="descDiv" style={{*!/*/}
      {/*  /!*    width: '100%',*!/*/}
      {/*  /!*    height: '100%'*!/*/}
      {/*  /!*  }}>*!/*/}
      {/*  /!*    <SimpleLine data={lineData}/>*!/*/}
      {/*  /!*  </div>*!/*/}
      {/*  /!*</div>*!/*/}
      {/*  /!*}*!/*/}

      {/*</div>*/}

        <div className="spaceDiv10"/>

       <BOTable
           schema={schema}
           rows={data}
           loading={isLoadingGraph}
           maxHeight={"65vh"}
       />

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}

    </div>
  );
}

export default items;
